import { createContext } from 'react';

export interface WixStyleReactDefaultsOverride {
  input: {
    size?: 'tiny' | 'small' | 'medium' | 'large';
  };
  button: {
    size?: 'tiny' | 'small' | 'medium' | 'large';
  };
}

const context = createContext<WixStyleReactDefaultsOverride>({
  input: {
    size: 'medium',
  },
  button: {
    size: 'medium',
  },
});
export const WixStyleReactDefaultsOverrideContext = context;
export const WixStyleReactDefaultsOverrideProvider = context.Provider;
export const WixStyleReactDefaultsOverrideConsumer = context.Consumer;
